module.exports = __webpack_public_path__ + "img/info2.adb0cb74.png";